// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Delivery_cardContainer__VfQ6X","currentRelay":"Delivery_currentRelay__2pwB3"};